module.exports = __webpack_public_path__ + "img/冬葵果.78b07d25.jpg";